import { Link } from "react-router-dom";

interface BackToAllProps {
  to: string;
  label: string;
  icon?: string;
}

/**
 * Small "back to all" quick link shown at the bottom of detail pages so
 * visitors can jump back up to the parent listing.
 */
export default function BackToAll({
  to,
  label,
  icon = "ri-arrow-left-line",
}: BackToAllProps) {
  return (
    <section className="bg-background-50 border-t border-background-200 py-10 md:py-12">
      <div className="w-full px-4 md:px-8 flex justify-center">
        <Link
          to={to}
          className="inline-flex items-center gap-2 text-sm md:text-base font-semibold text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className={`${icon} text-lg`}></i>
          {label}
        </Link>
      </div>
    </section>
  );
}